import Venue from '../model/Venue';

export class VenueService {
  constructor(
    $q,
    $log,
    API_URL,
    APIService
  ) {
    "ngInject";
    this.$q = $q;
    this.$log = $log;
    this.APIService = APIService;
    this.NEARBY_VENUES_URL = '/get_nearby_venues';
    this.VENUE_SEARCH_URL = '/venue_search';
    this.GET_EXCUTION_TEAM_VENUES_URL = '/get_execution_team_venues';
  }

  create(data) {
    data = data || {};
    return this.$q.when(new Venue(data));
  }

  // Google Places Search
  nearbyVenueSearch(coords, clients_id, radius, config = null) {
    let url = this.NEARBY_VENUES_URL;
    config = config || {};
    config.params = {
      latlng: coords,
      clients_id: clients_id,
      radius: radius
    };

    return this.APIService.get(url, config)
  }

  // Database venues search
  venueSearch(params, config = null) {
    let url = this.VENUE_SEARCH_URL;

    config = config || {};
    config.params = params;

    return this.APIService.get(url, config);
  }

  // Gets all venues associated to the user's execution team if that user is on one
  getExecutionTeamVenues(programs_id, clients_id) {
    let url = this.GET_EXCUTION_TEAM_VENUES_URL;

    let config = {};
    config.params = {
      programs_id: programs_id,
      clients_id: clients_id
    }
    config.force = true;
    return this.APIService.get(url, config);

  }
}

import m from './module';
m.service('VenueService', VenueService);
